/**
 * Geolocation Store - Pinia
 * 
 * Manages GPS position, view centering, and current geolocation data.
 * Migrated from VueX module src/store/modules/geolocation/
 */

import { defineStore } from 'pinia';

export const useGeolocationStore = defineStore('geolocation', {
  state: () => ({
    // Center of current LonLat
    geoPositionCenter: [0, 0],
    // Center of map, when user moved the map manually via mouse or touch
    temporaryCenterOfManuallyMovedMap: [0, 0],
    // Center View and follow recording, initially true
    lockViewToCenter: true,
    // Current Geolocation (for immediate display on screen)
    currentGeolocation: {
      accuracy: 0,
      altitude: 0,
      altitudeAccuracy: 0,
      heading: 0,
      lat: 0,
      lon: 0,
      speed: 0,
      currentDistance: 0,
      distanceM: 0,
      distanceKM: 0
    },
    // Geolocation initial data (for reverse GeoIP - not currently in use)
    startGeoLocData: {
      lat: 0,
      lon: 0,
      accuracy: null,
      altitude: null,
      altitudeAccuracy: null,
      heading: null,
      speed: null,
      latFixedFloat: 0,
      lonFixedFloat: 0,
      plz: null,
      city: null,
      district: null,
      label: null,
      houseNumber: null,
      neighbourhood: null,
      county: null,
      country: null,
      state: null,
      additionalData: null
    },
    zoomInDuration: 750
  }),

  getters: {
    getLockViewToCenter: (state) => state.lockViewToCenter,
    getTemporaryCenterOfManuallyMovedMap: (state) => state.temporaryCenterOfManuallyMovedMap,
    getCurrentGeolocation: (state) => state.currentGeolocation
  },

  actions: {
    setLockViewToCenter (bool) {
      this.lockViewToCenter = bool;
    },

    setTemporaryCenterOfManuallyMovedMap (payload) {
      this.temporaryCenterOfManuallyMovedMap = payload;
    },

    setGeoPositionCenter (payload) {
      this.geoPositionCenter = payload;
    },

    /**
     * Set current geolocation from position array
     * @param {Array} payload - [lon, lat, altitude, timestamp, heading, speed, accuracy, altitudeAccuracy, recording, distance, steps]
     */
    setCurrentGeolocation (payload) {
      this.currentGeolocation.lon = payload[0];
      this.currentGeolocation.lat = payload[1];
      this.currentGeolocation.altitude = payload[2];
      this.currentGeolocation.heading = payload[4];
      this.currentGeolocation.speed = payload[5];
      this.currentGeolocation.accuracy = payload[6];
      if (payload[9]) {
        this.currentGeolocation.distanceM = payload[9].m;
        this.currentGeolocation.distanceKM = payload[9].km;
      }
    },

    setCurrentDistance (val) {
      this.currentGeolocation.currentDistance = val;
    }
  }
});
